import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import ShareBox from 'components/share-box'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 3, 1),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
    marginBottom: theme.spacing(0.75),
  },
  subtitle: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  content: {
    padding: theme.spacing(1, 3, 3),
  },
}))

const SocialShareDialog = ({
  trigger,
  shareUrl,
  shareTitle,
  dialogTitle,
  dialogSubtitle,
  bookingType,
  showBookingUrl,
  showScheduleUrl,
  showProfileUrl,
  shareSubtitle,
  att,
}) => {
  const classes = useStyles()
  const resolvedTitle =
    dialogTitle ?? (showBookingUrl ? 'Share your booking link' : 'Share')
  const resolvedSubtitle =
    dialogSubtitle ??
    (showBookingUrl
      ? 'Let students book lessons directly from your Coach Profile'
      : null)

  return (
    <Dialog trigger={trigger} maxWidth="sm" fullWidth showCloseButton>
      {() => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              {resolvedTitle}
            </Typography>
            {resolvedSubtitle ? (
              <Typography className={classes.subtitle}>
                {resolvedSubtitle}
              </Typography>
            ) : null}
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <ShareBox
              url={shareUrl}
              title={shareTitle}
              subtitle={shareSubtitle}
              bookingType={bookingType}
              showBookingUrl={showBookingUrl}
              showScheduleUrl={showScheduleUrl}
              showProfileUrl={showProfileUrl}
              att={att}
              shareId={bookingType?.id || null}
            />
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default SocialShareDialog
